import React, { useEffect, useState, useContext, useRef } from 'react';
import { message, Form, Row, Tabs, Space, Typography } from 'antd';
import { CommonCloudFirestore } from '../../services/CommonCloudFirestore';
import {
    CONFIGURATION_CATEGORY,
    DOCUMENT_CONFIGURATION,
    LISTENER_CONFIGURATIONS
} from '../../../shared/types/firestoreType';
import { ModalContext } from '../../../shared/context/ModalContext';

import Loading from '../../../shared/components/Loading/Index';
import Header from './Header';
import CategoryForm from './CategoryForm';

import categoryIcon from '../../../assets/icons/category/01.svg';
import sectionIcon from '../../../assets/icons/section/01.svg';

export default function Index(_) {
    const modal = useContext(ModalContext);
    const configurationFirestore = new CommonCloudFirestore(DOCUMENT_CONFIGURATION);
    const categoryFormRef = useRef();

    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [categoryId, setCategoryId] = useState(CONFIGURATION_CATEGORY);

    useEffect(() => {
        onLoad();
    }, []);

    const onLoad = async () => {
        setLoading(true);
        var response = await configurationFirestore.getDocuments();
        var categoryResponse = response.find(m => m.id === categoryId);

        if (categoryResponse)
            categoryFormRef.current.onLoad(categoryResponse);
        else
            categoryFormRef.current.onLoadDefault();

        setLoading(false);
    };

    const onSave = async () => {
        var validations = await form.validateFields().then(() => true).catch(() => false);
        if (!validations) {
            message.warning('Por favor completa los datos del formulario.', 7);
            return;
        }

        modal.confirm("¿Esta seguro de realizar la acción?", async () => {
            setLoading(true);

            var documents = [];
            var categoryDocument = categoryFormRef.current.getFieldsValue();
            categoryDocument.id = CONFIGURATION_CATEGORY;
            documents.push(categoryDocument);

            var response = await configurationFirestore.setDocuments(documents, [LISTENER_CONFIGURATIONS]);
            if (response)
                message.success(`Datos guardados correctamente.`, 6);
            else
                message.error('Ocurrió un error inesperado.', 6);

            setLoading(false);
        });
    };

    return (
        <Row justify={'center'}>
            <div className='w-100' style={{ maxWidth: 570 }}>
                <Loading visible={loading} text="cargando">
                    <Header
                        onSave={onSave}
                    />
                    <Tabs
                        defaultActiveKey="2"
                        type='card'
                        size='large'
                        items={[
                            {
                                key: 'category',
                                label: (
                                    <Space wrap>
                                        <div className='vertical-center'>
                                            <img src={categoryIcon} height={18} alt="" />
                                        </div>
                                        <Typography.Text style={{ fontSize: 16 }}>Categorías</Typography.Text>
                                    </Space>
                                ),
                                children: (
                                    <CategoryForm
                                        ref={categoryFormRef}
                                    />
                                )
                            },
                            {
                                key: 'section',
                                label: (
                                    <Space wrap>
                                        <div className='vertical-center'>
                                            <img src={sectionIcon} height={18} alt="" />
                                        </div>
                                        <Typography.Text style={{ fontSize: 16 }}>Secciones</Typography.Text>
                                    </Space>
                                ),
                                children: ('En construcción')
                            }
                        ]}
                    />
                </Loading>
            </div>
        </Row>
    )
}